import { useState } from 'react';
import { maskEmail } from '../../../../../app/common/helpers/mask';
export var useEmailInput = function (_a) {
    var maskContactInfo = _a.maskContactInfo, onClientInfoUpdated = _a.onClientInfoUpdated, form = _a.form;
    var _b = useState(form.getValues('email')), displayEmail = _b[0], setDisplayEmail = _b[1];
    var onChange = function (email) {
        onClientInfoUpdated('email', email);
        setDisplayEmail(email);
    };
    var setEmailFromSelectedClient = function (clientEmail) {
        if (clientEmail) {
            form.setValue('email', clientEmail);
            setDisplayEmail(maskContactInfo ? maskEmail(clientEmail) : clientEmail);
        }
        else {
            setDisplayEmail('');
            form.setValue('email', '');
        }
    };
    return {
        value: displayEmail,
        onChange: onChange,
        setEmailFromSelectedClient: setEmailFromSelectedClient,
    };
};
